import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, User, ArrowRight, ShieldAlert } from "lucide-react";
import { login } from "../lib/adminAuth";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(username, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#F9F8F5] flex items-center justify-center px-6 py-12">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white rounded-3xl shadow-[0_40px_100px_-20px_rgba(0,0,0,0.1)] border border-[#141414]/5 overflow-hidden"
      >
        <div className="bg-[#141414] p-10 text-center">
          <div className="w-16 h-16 bg-[#835F21] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#835F21]/20">
            <Lock className="text-white" size={28} />
          </div>
          <h1 className="font-display font-medium text-2xl text-white tracking-tight">Admin Authentication</h1>
          <p className="font-sans text-[11px] font-bold tracking-[0.2em] text-[#835F21] uppercase mt-2">Astraum Task Force</p>
        </div>

        <form onSubmit={handleLogin} className="p-10 space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-100 p-4 rounded-xl flex items-center gap-3 text-red-600">
              <ShieldAlert size={18} />
              <span className="font-sans text-[13px] font-medium uppercase tracking-wide">{error}</span>
            </div>
          )}

          <div className="space-y-2">
            <label className="font-sans text-[10px] font-bold tracking-[0.2em] uppercase text-[#141414]/40 ml-1">Username</label>
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 text-[#141414]/20" size={18} />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full h-14 bg-[#F9F8F5] border-none rounded-2xl pl-12 pr-4 font-sans text-[14px] focus:ring-2 focus:ring-[#835F21]/20 outline-none transition-all placeholder:text-[#141414]/20"
                placeholder="Enter admin identifier"
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="font-sans text-[10px] font-bold tracking-[0.2em] uppercase text-[#141414]/40 ml-1">Secret Key</label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-[#141414]/20" size={18} />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-14 bg-[#F9F8F5] border-none rounded-2xl pl-12 pr-4 font-sans text-[14px] focus:ring-2 focus:ring-[#835F21]/20 outline-none transition-all placeholder:text-[#141414]/20"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-14 bg-[#141414] hover:bg-[#835F21] text-white rounded-2xl font-sans text-[11px] font-bold tracking-[0.2em] uppercase transition-all duration-300 flex items-center justify-center gap-3 group disabled:opacity-50"
          >
            {loading ? "Verifying..." : "Authorize Access"}
            {!loading && <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />}
          </button>
        </form>
      </motion.div>
    </main>
  );
}
